import script from "./InitAuthMixin.vue?vue&type=script&lang=ts"
export * from "./InitAuthMixin.vue?vue&type=script&lang=ts"

export default script